// extracted by mini-css-extract-plugin
export default {"chip":"ProjectsOverviewPage_chip__+3Rcf","alertNotificationsHeader":"ProjectsOverviewPage_alertNotificationsHeader__uJH0m","helpIcon":"ProjectsOverviewPage_helpIcon__H5Z6S"};